import type { ChartConfig } from "@/ds/shadcn/components/ui/chart";
import type { VariantMarketPriceResponseModel } from "@/features/products/api/useProduct";

const GraphColors = ["#5AAA3E", "#3E90AA", "#8E3EAA", "#D74111", "#E8CE17"];

export const getProductHistoricalPricingChartConfig = (responseModel: VariantMarketPriceResponseModel[]): ChartConfig => {
	return responseModel.reduce((cfg, variant, index) => ({
		...cfg,
		[variant.variantId]: {
			label: variant.variantName,
			color: GraphColors[index % GraphColors.length]
		}
	}), { });
};
